//===----------------------------------------------------------------------===//
//
//  Copyright 2024-2026 Trovares Inc. dba Rocketgraph.  All rights reserved.
//
//===----------------------------------------------------------------------===//

import { createContext } from 'react';

import { type SettingsScope } from '@/components/Settings/settingsSections';

export interface SettingsContextValue {
  open: boolean;
  selectedLeafKey: string;
  // Which entry point opened the settings, and therefore which groups it
  // shows. Undefined means every group the user may see, which is what the
  // callers that predate the split still ask for.
  scope?: SettingsScope;
  openSettings: (leafKey?: string, scope?: SettingsScope) => void;
  // Switches the active leaf while the settings UI is already open (in-modal
  // nav).  The context is the single owner of the selected leaf, so navigating
  // and opening to a specific leaf share one source of truth.
  selectLeaf: (leafKey: string) => void;
  closeSettings: () => void;
}

const SettingsContext = createContext<SettingsContextValue | null>(null);

export { SettingsContext };
